/**
 * Returns true if `key` has already fired in this browser session (and marks
 * it fired). Pure + storage-injectable for testing. On SSR / when storage is
 * unavailable it returns false — never dedupes, so an event still fires (there
 * are no real events during SSR anyway). Keys are namespaced under `se_fired:`.
 */
export function firedOncePerSession(
  key: string,
  storage?: Pick<Storage, 'getItem' | 'setItem'>
): boolean {
  const k = `se_fired:${key}`
  try {
    // Reading `window.sessionStorage` itself can THROW (not just getItem/setItem)
    // on iOS Safari with storage disabled (private mode / ITP / content blockers),
    // so the access must live inside the try — a default-param fallback would
    // evaluate before the body and escape this guard.
    const store =
      storage ??
      (typeof window !== 'undefined' ? window.sessionStorage : undefined)
    if (!store) return false
    if (store.getItem(k)) return true
    store.setItem(k, '1')
    return false
  } catch {
    // Private-mode / quota / SecurityError → behave like "not yet fired", don't throw.
    return false
  }
}
